const News = (app) => {
  app.post("/news/create", async ({ api, flash, req, res }) => {
    const { body, files } = req;

    const bodyToSend = {
      title: body.title,
      text:
        typeof body.text === "string" ? body.text : JSON.stringify(body.text),
      link: body.link || "",
      imageUrl: body.imageUrl || "",
      chips:
        typeof body.chips === "string"
          ? body.chips
          : JSON.stringify(body.chips || []),
      published: body.published === "true" || body.published === true,
      createdAt: body.createdAt,
    };

    try {
      await api("news", {
        method: "POST",
        body: bodyToSend,
        files,
      });

      flash("success", "Announcement created");
      res.refreshWith({ modal: "", newsId: "" }, { url: "back", hash: "#_" });
    } catch (error) {
      flash("error", error.message);
      res.refreshWith(
        { "modal[type]": "new-news" },
        { url: "back", hash: "#_" }
      );
    }
  });

  app.post("/news/update", async ({ api, flash, req, res }) => {
    const { body, files } = req;
    const { newsId } = body;

    try {
      const updateBody = {};

      if (body.title !== undefined) updateBody.title = body.title;
      if (body.text !== undefined) {
        updateBody.text =
          typeof body.text === "string" ? body.text : JSON.stringify(body.text);
      }
      if (body.link !== undefined) updateBody.link = body.link;
      if (body.imageUrl !== undefined) updateBody.imageUrl = body.imageUrl;
      if (body.chips !== undefined) {
        updateBody.chips =
          typeof body.chips === "string"
            ? body.chips
            : JSON.stringify(body.chips);
      }
      if (body.published !== undefined) {
        updateBody.published =
          body.published === "true" || body.published === true;
      }
      if (body.createdAt !== undefined) updateBody.createdAt = body.createdAt;

      await api(`news/${newsId}`, {
        method: "PUT",
        body: updateBody,
        files,
      });

      flash("success", "Announcement updated");
      res.refreshWith({ modal: "", newsId: "" }, { url: "back", hash: "#_" });
    } catch (error) {
      flash("error", error.message);
      res.refreshWith(
        { "modal[type]": "edit-news", newsId },
        { url: "back", hash: "#_" }
      );
    }
  });

  app.post("/news/mark-read", async ({ api, req, res }) => {
    const { newsIds } = req.body;
    const ids = Array.isArray(newsIds) ? newsIds : [newsIds].filter(Boolean);
    if (ids.length) {
      await api("news-read", { method: "POST", body: { newsIds: ids } });
    }
    res.refreshWith(
      { "modal[type]": "whats-new" },
      { url: "back", hash: "#_" }
    );
  });

  app.post("/news/delete", async ({ api, flash, req, res }) => {
    const { body } = req;
    const { newsId, page } = body;

    try {
      await api(`news/${newsId}`, { method: "DELETE" });
      flash("success", "Announcement deleted");
      res.refreshWith(page ? { page } : {}, { url: "back", hash: "#_" });
    } catch (error) {
      flash("error", error.message);
      res.refreshWith({}, { url: "back", hash: "#_" });
    }
  });
};

export default News;
